import React, {useMemo} from 'react';
import View from './view';
import {IOwnProps, Picker} from './model';
import {FilePickerController} from './controller';

import {useAppDispatch} from '../../../redux';
import {addNotification} from '../../../redux/actions/snackbar';
import {SnackbarNotificationType} from '../snackbar/model';

export const FilePicker: React.FC<IOwnProps> = ({
  pickerOptions,
  onUploadStart,
  onUploadError,
  onUploadEnd,
  disabled,
}) => {
  const controller: Picker = useMemo(() => new FilePickerController(pickerOptions || {}), [pickerOptions]);
  const dispatch = useAppDispatch();
  const handleUploadStart = () => {
    if (onUploadStart) {
      onUploadStart();
    }
  };

  const handlePress = async () => {
    controller.pick(handleUploadStart, (err, results) => {
      if (err) {
        dispatch(
          addNotification({
            message: err?.message ?? err.toString(),
            type: SnackbarNotificationType.Error,
          }),
        );
        if (onUploadError) {
          onUploadError(err);
        }
      }

      if (results) {
        onUploadEnd(results);
      }
    });
  };

  return React.createElement(View, {
    onPress: handlePress,
    disabled: !!disabled,
  });
};
